import { render, staticRenderFns } from "./Pagetop.vue?vue&type=template&id=16bccdae&scoped=true"
import script from "./Pagetop.vue?vue&type=script&lang=js"
export * from "./Pagetop.vue?vue&type=script&lang=js"
import style0 from "./Pagetop.vue?vue&type=style&index=0&id=16bccdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bccdae",
  null
  
)

export default component.exports